import ApiConfig from '../apiConfig/apiConfig';
import { Fetch } from '../apiConfig/Fetch';

const PatientService = {

    getPatientslist: async (page, pageSize) => {
        const { baseUrl, getPatientslist } = ApiConfig;

        const url = `${baseUrl}${getPatientslist}?page=${page}&pageSize=${pageSize}`;
        console.log(url);

        // const url = baseUrl + getPatientslist;
        // console.log(url)
        const headers = new Headers({
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        });


        const patientsServicePromise = await Fetch(
            url,
            "GET",
            headers,
            '',
            "services_patients",
            true
        );
        return patientsServicePromise;
    },

};

export default PatientService;